import React from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";

const StatColumn = ({ id, value, label, className = "reco-stat" }) => (
  <Grid.Column
    mobile={7}
    tablet={5}
    computer={3}
    style={{ paddingBottom: "0.5rem" }}
    className={className}
    role="group"
    aria-labelledby={`${id}-label`}
  >
    <div className="reco-stat-body">
      <h4 id={`${id}-label`}>{value}</h4>
      <h5>{label}</h5>
    </div>
  </Grid.Column>
);

StatColumn.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string
};

StatColumn.defaultProps = {
  className: "reco-stat"
};

export default StatColumn;
